import { Box } from '@mantine/core';
import { useParams } from 'wouter';
import { FinalInvoiceDocument } from '@/components/InvoiceDetailsModal/FinalInvoiceDocument';

/** The shareable final invoice page; same layout as the proforma's. */
export default function FinalInvoicePage() {
  const { id } = useParams();
  return (
    <Box p="md">
      <FinalInvoiceDocument id={Number(id)} />
    </Box>
  );
}
